import Proxy from '../Proxy';

class StatsFinanceProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/finance', parameters);
  }

  general() {
    return this.submit('get', `${this.endpoint}/general`);
  }
}

export default StatsFinanceProxy;
